import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";

const DAYS = [["0", "Lundi"], ["1", "Mardi"], ["2", "Mercredi"], ["3", "Jeudi"], ["4", "Vendredi"], ["5", "Samedi"], ["6", "Dimanche"]];

export default function AdminAvailability() {
  const [avail, setAvail] = useState(null);
  const [blocked, setBlocked] = useState([]);
  const [newBlock, setNewBlock] = useState({ date: "", full_day: true, start_time: "10:00", end_time: "18:00", reason: "" });

  const loadBlocked = () => api.get("/admin/blocked-slots").then((r) => setBlocked(r.data)).catch(() => {});
  useEffect(() => {
    api.get("/admin/availability").then((r) => setAvail(r.data)).catch(() => {});
    loadBlocked();
  }, []);

  const setDay = (d, k, v) => setAvail((a) => ({ ...a, days: { ...a.days, [d]: { ...a.days[d], [k]: v } } }));

  const saveAvail = async () => {
    try { await api.put("/admin/availability", { data: { days: avail.days } }); toast.success("Horaires enregistrés"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  const addBlock = async () => {
    if (!newBlock.date) { toast.error("Choisissez une date"); return; }
    try { await api.post("/admin/blocked-slots", { data: newBlock }); toast.success("Fermeture ajoutée"); setNewBlock({ ...newBlock, date: "", reason: "" }); loadBlocked(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  const removeBlock = async (id) => { await api.delete(`/admin/blocked-slots/${id}`); loadBlocked(); };

  if (!avail) return <div className="text-slate-500">Chargement…</div>;

  return (
    <div data-testid="admin-availability">
      <h1 className="font-display font-black text-3xl mb-8">Disponibilités</h1>

      <div className="card-dark p-6 mb-8">
        <h2 className="font-display font-bold text-lg mb-5">Horaires hebdomadaires</h2>
        <div className="space-y-3">
          {DAYS.map(([d, label]) => (
            <div key={d} className="flex flex-wrap items-center gap-4 py-2 border-b border-white/5">
              <label className="flex items-center gap-2 w-32 cursor-pointer">
                <input type="checkbox" data-testid={`day-open-${d}`} className="accent-amber-400 w-4 h-4" checked={!!avail.days[d]?.open} onChange={(e) => setDay(d, "open", e.target.checked)} />
                <span className="text-sm">{label}</span>
              </label>
              {avail.days[d]?.open ? (
                <div className="flex items-center gap-2 text-sm">
                  <input type="time" className="input-dark !py-1.5 !w-32" value={avail.days[d]?.start} onChange={(e) => setDay(d, "start", e.target.value)} />
                  <span className="text-slate-500">→</span>
                  <input type="time" className="input-dark !py-1.5 !w-32" value={avail.days[d]?.end} onChange={(e) => setDay(d, "end", e.target.value)} />
                </div>
              ) : <span className="text-sm text-slate-600">Fermé</span>}
            </div>
          ))}
        </div>
        <button onClick={saveAvail} data-testid="save-availability-btn" className="btn-gold mt-6">Enregistrer les horaires</button>
      </div>

      <div className="card-dark p-6">
        <h2 className="font-display font-bold text-lg mb-5">Fermetures exceptionnelles & créneaux bloqués</h2>
        <div className="flex flex-wrap items-end gap-3 mb-6">
          <div><label className="label-dark">Date</label><input type="date" data-testid="block-date" className="input-dark" value={newBlock.date} onChange={(e) => setNewBlock({ ...newBlock, date: e.target.value })} /></div>
          <label className="flex items-center gap-2 cursor-pointer pb-3"><input type="checkbox" className="accent-amber-400 w-4 h-4" checked={newBlock.full_day} onChange={(e) => setNewBlock({ ...newBlock, full_day: e.target.checked })} /><span className="text-sm">Journée entière</span></label>
          {!newBlock.full_day && (
            <>
              <div><label className="label-dark">De</label><input type="time" className="input-dark" value={newBlock.start_time} onChange={(e) => setNewBlock({ ...newBlock, start_time: e.target.value })} /></div>
              <div><label className="label-dark">À</label><input type="time" className="input-dark" value={newBlock.end_time} onChange={(e) => setNewBlock({ ...newBlock, end_time: e.target.value })} /></div>
            </>
          )}
          <div className="flex-1 min-w-[150px]"><label className="label-dark">Motif</label><input className="input-dark" value={newBlock.reason} onChange={(e) => setNewBlock({ ...newBlock, reason: e.target.value })} /></div>
          <button onClick={addBlock} data-testid="add-block-btn" className="btn-gold !py-2.5"><Plus size={16} /> Ajouter</button>
        </div>
        <div className="space-y-2">
          {blocked.length === 0 ? <p className="text-slate-500 text-sm">Aucune fermeture programmée.</p> : blocked.map((b) => (
            <div key={b.id} className="flex items-center justify-between bg-black/30 rounded-lg px-4 py-2.5 text-sm">
              <span><span className="font-mono text-gold">{b.date}</span> — {b.full_day ? "Journée entière" : `${b.start_time} → ${b.end_time}`} {b.reason && <span className="text-slate-500">· {b.reason}</span>}</span>
              <button onClick={() => removeBlock(b.id)} className="text-slate-400 hover:text-red-400"><Trash2 size={15} /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
